import React, { useEffect, useRef, useState } from 'react';
import './Home.css';
import HomeGames from '../../Components/HomeGames/HomeGames';
import Footer from '../../Components/Footer/Footer';
import AboutSection from '../../Components/AboutSection/AboutSection';
import AdComponent from '../../Components/AdComponent/AdComponent';
import AdLoader from '../../Components/AdLoader/AdLoader';
import { FaCoins, FaVideo } from 'react-icons/fa';
import {
  initScrollInterstitial,
  initWelcomeAd,
  loadRewardAd,
  navigateWithInterstitial,
  subscribeAdLoading,
} from '../../utils/adManager';

function Home() {
  const [showOopsPopUp, setShowOopsPopUp] = useState(false);
  const [pendingUrl, setPendingUrl] = useState(null);
  const [coins, setCoins] = useState(() => parseInt(localStorage.getItem('user_coins')) || 0);
  const [adLoading, setAdLoading] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    localStorage.setItem('user_coins', coins);
  }, [coins]);

  useEffect(() => {
    window.onAdRewarded = () => {
      setCoins((prev) => prev + 10);
      setShowOopsPopUp(false);
    };

    window.onAdStarted = () => {};

    initWelcomeAd();
    initScrollInterstitial(contentRef.current);

    return subscribeAdLoading(setAdLoading);
  }, []);

  const handlePlayClick = (url) => {
    if (coins > 0) {
      setCoins((prev) => prev - 10);
      navigateWithInterstitial(url);
      return;
    }

    setPendingUrl(url);
    setShowOopsPopUp(true);
  };

  const handleClaim = () => {
    loadRewardAd();
  };

  const watchAdForCoins = () => {
    loadRewardAd();
  };

  const handleSkip = () => {
    if (pendingUrl) {
      navigateWithInterstitial(pendingUrl);
    } else {
      setShowOopsPopUp(false);
    }
  };

  return (
    <>
      <AdLoader visible={adLoading} />

      {showOopsPopUp && (
        <div className="popup-overlay">
          <div className="popup-content oops-popup text-center">
            <div className="oops-header">
              <div className="oops-title-text">OOPS</div>
            </div>
            <div className="oops-text">You don't have enough coins to join this contest.</div>
            <div className="oops-subtext">Just watch an ad & earn 10 coins</div>
            <button className="claim-btn" onClick={handleClaim} disabled={adLoading}>
              CLAIM
            </button>
            <button className="skip-text" onClick={handleSkip} disabled={adLoading}>
              Skip
            </button>
            <span
              style={{
                position: 'absolute',
                top: '50%',
                right: '-30px',
                transform: 'rotate(90deg)',
                color: '#999',
                fontSize: '12px',
              }}
            >
              Ad
            </span>
          </div>
        </div>
      )}

      <div className="Main_Bg">
        <div className="content-section" ref={contentRef}>
          <div className="p-3">
            <AdComponent
              client="ca-pub-2248973218739803"
              slot="9826680987"
              format="auto"
              style={{ display: 'block', width: '100%', height: '280px' }}
            />

            <div className="coin-dashboard position-relative">
              <div className="coin-amount-box">
                <FaCoins style={{ color: '#fbc02d', fontSize: '24px' }} />
                <span style={{ fontWeight: '800', fontSize: '20px' }}>{coins} Coins</span>
              </div>
              <div className="mt-3 d-flex flex-column align-items-center justify-content-center">
                <button className="add-coin-btn" onClick={watchAdForCoins} disabled={adLoading}>
                  <FaVideo /> Get 10 Free Coins
                </button>
              </div>
              <div className="position-absolute end-0 bottom-0 p-2 px-3" style={{ opacity: 0.5 }}>
                Ad
              </div>
            </div>

            <div className="px-2">
              <div className="custom-card mt-4 py-4">
                <div className="custom-heading h5">Prefer games which you want to play</div>
                <button
                  className="mt-4 custom-button p-2 px-2"
                  id="cargame"
                  onClick={() => handlePlayClick('https://www.playpokigames.com')}
                >
                  Arcade
                </button>
                <button
                  className="mt-4 ms-2 custom-button p-2 px-2"
                  onClick={() => handlePlayClick('https://www.playpokigames.com')}
                >
                  Puzzle
                </button>
                <button
                  className="mt-4 ms-2 custom-button p-2 px-2"
                  onClick={() => handlePlayClick('https://www.playpokigames.com')}
                >
                  Casual
                </button>
                <button
                  className="mt-4 ms-2 custom-button p-2 px-2"
                  onClick={() => handlePlayClick('https://www.playpokigames.com')}
                >
                  Action
                </button>
              </div>
            </div>

            <div className="pt-4">
              <HomeGames onPlay={handlePlayClick} />
            </div>

            <div className="px-2 my-4">
              <button
                className="custom-button w-100 py-3"
                onClick={() => handlePlayClick('https://www.playpokigames.com')}
              >
                More Games
              </button>
            </div>

            <AboutSection />
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default Home;
